'use client'

import { Button } from '@/components/ui/button'
import { queryKeys } from '@/hooks/queries'
import { PaymentsService } from '@/services/payments.service'
import { useQueryClient } from '@tanstack/react-query'
import { Loader2, X } from 'lucide-react'
import { useState } from 'react'
import { toast } from 'sonner'

/**
 * Отмена запланированной смены тарифа. На бэк передаётся id ТЕКУЩЕЙ активной
 * подписки. После успеха инвалидируем кэш подписок — запланированный переход
 * исчезает, снова доступна смена тарифа.
 */
export function CancelTariffChangeButton({
	subscriptionId,
	className,
}: {
	subscriptionId: string
	className?: string
}) {
	const queryClient = useQueryClient()
	const [loading, setLoading] = useState(false)

	async function cancel() {
		setLoading(true)
		try {
			await PaymentsService.cancelTariffChange(subscriptionId)
			toast.success('Запланированная смена тарифа отменена')
			queryClient.invalidateQueries({ queryKey: queryKeys.subscriptions })
		} catch (error: any) {
			toast.error(
				error.response?.data?.message || 'Не удалось отменить смену тарифа'
			)
		} finally {
			setLoading(false)
		}
	}

	return (
		<Button
			variant='outline'
			size='sm'
			onClick={cancel}
			disabled={loading}
			// Тёмная кнопка + белый текст + янтарная рамка. Используем только классы,
			// уже присутствующие в бандле (text-white/bg-gray-900-60/border-amber-500-40),
			// чтобы текст был виден без перекомпиляции CSS дев-сервера.
			className={`bg-gray-900/60 text-white border-amber-500/40 hover:bg-gray-900 hover:text-white ${
				className ?? ''
			}`}
		>
			{loading ? (
				<Loader2 className='w-4 h-4 mr-1 animate-spin' />
			) : (
				<X className='w-4 h-4 mr-1' />
			)}
			Отменить смену тарифа
		</Button>
	)
}
